<template>
  <div>
    <div class="row">
      <div class="flex md12 xs12 lg12">
        <sp-360-panel :title="$t('covid.cidadeSolidaria.titulo')"
          :footerText="$t('rodape.fonteData', {fonte : 'covid.cidadeSolidaria.fonte', data : dataRef})"
          :footerComplementar="$t('covid.cidadeSolidaria.rodape')">

         <div>
            <div id="multiselects" class="flex-box">
              <multiselect id="selectSubprefeituras" name="Subprefeituras" placeholder="Selecione uma Subprefeitura"
                :value="subSel" :options="subs" track-by="nome" label="nome" :close-on-select="true" :show-labels="false"
                @input="updateMultiSelect" />
            </div>

            <div class="flex-box">
              <sp-map v-on:regiaoClicada="filtrarPorRegiao($event)" :habilitarAnimacaoClique="true" ref="mapa"
                id="mapaSP" />
              <div id="tabelaDoacoesRegioes" class="flex xs12 sm12 lg12 ">
                <div class="">

                  <va-input class="" v-model="termoBuscaSituacao" placeholder="Pesquisar" removable
                    @input="buscaTermoSituacao">
                    <va-icon name="fa fa-search" slot="prepend" />
                  </va-input>
                </div>
                <sp360-data-table id="tabelaDoacoes" ref="tabelaDoacoes" :apiMode="false" :data="tableData.data"
                  :fields="tableFields" :perPage="itemsPerPage[0].value" :onEachSide="onEachSide"
                  :dataModeFilterableFields="dataModeFilterableFields" :sortFunctions="sortFunctionsServ"
                  :filterInputShown="true" :title="this.tituloTabela" :footerObj="this.municipio" />
              </div>

            </div>
         </div>

          <div class="flex md12 xs12 lg12">
            <va-list-separator/>
            <br>
            <div id="tabelaDoacoesRegioes">
              <div class="flex-box">
                <multiselect id="selectSubprefeituras" name="Subprefeituras" placeholder="Selecione uma Subprefeitura"
                  :value="subSel" :options="subs" track-by="nome" label="nome" :close-on-select="true"
                  :show-labels="false" @input="updateMultiSelect" />
                <!-- <va-input class="" v-model="termoBuscaSituacao" placeholder="Pesquisar" removable
                  @input="buscaTermoSituacao">
                  <va-icon name="fa fa-search" slot="prepend" />
                </va-input> -->
              </div>
              <sp360-data-table id="tabelaInstituicao" ref="tabelaInstituicao" :apiMode="false"
                :data="tableData.dataInstituicao" :fields="tableFieldsInstituicao" :perPage="itemsPerPage[0].value"
                :onEachSide="onEachSide" :dataModeFilterableFields="dataModeFilterableFields"
                :sortFunctions="sortFunctionsServ" :filterInputShown="true" :title="tituloTabelaInstituicao" />
            </div>
          </div>

        </sp-360-panel>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import CorUtil from '@/utils/CorUtils'
import Constantes from '@/utils/ConstantesGlobais'
import * as d3 from 'd3'
import Linha from '@/components/statistics/charts/GraficoLinha.vue'
import MetodosGlobais from '@/utils/MetodosGlobais'
import Multiselect from 'vue-multiselect'
import SpCard from '@/components/dashboard/SP360Card'
import Sp360Panel from '@/components/ui/sp360-panel/sp360-panel'
import Sp360DataTable from '@/components/ui/dataTable/sp360datatable'
import SpMap from '@/components/maps/360-maps/SPMap'
import SPMapaNomes from '@/utils/SPMapaNomes'
import Sp360Chart from '@/components/ui/chart/sp360chart'
import Sp360List from '@/components/ui/list/VaList'

export default {
  name: 'covid-19',
  components: {
    SpCard,
    Sp360Panel,
    Sp360DataTable,
    SpMap,
    Multiselect,
    Linha,
    Sp360Chart,
    SPMapaNomes,
    Sp360List,
  },
  data () {
    return {
      dataRef: null,
      subSel: '',
      subs: [],
      subSelecionada: null,
      data: null,
      municipio: null,
      termoBuscaSituacao: null,
      dadosFooter: [],
      footerTabelaMapa: null,
      indexTabela: 0,
      corteTemporal: [this.$t('mainDashboard.multiselect.ultimoMesFechado'), this.$t(
        'mainDashboard.multiselect.ultimoSemestreFechado'), this.$t('mainDashboard.multiselect.ultimos30Dias'),
      this.$t('mainDashboard.multiselect.ultimos180Dias'),
      ],
      corteTemporalEscolhido: 'Último mês fechado',
      tituloDashboard: this.$t('mainDashboard.title'),
      tooltipOptions: {},
      tituloTabela: this.$t('covid.cidadeSolidaria.tabelaTitulo'),
      munAtual: this.$t('mainDashboard.general'),
      ultimoClickNomeSub: null,
      ultimoClickIdSub: 0,
      solicitacoes30: {},
      solicitacoes180: {},
      solicitacoesUltimoMes: {},
      solicitacoesUltimoSemestre: {},
      cores: {
        claro: '#f1f1fa',
        medio: '#9c9cd4',
        escuro: '#3b3b72',
      },

      itemsPerPage: [{
        value: 10, // Constantes.PARAMETROS_DASHBOARD.SP156.QTD_DE_LINHAS_TABELAS_SERVICO_POR_REGIAO,
      },
      {
        value: 10, // Constantes.PARAMETROS_DASHBOARD.SP156.QTD_DE_LINHAS_TABELAS_SERVICO_POR_REGIAO,
      },
      ],
      tableData: {
        'data': [],
        'dataInstituicao': [],
      },
      tableFields: [{
        name: 'posicao',
        title: '#',
        titleClass: 'center aligned',
        dataClass: 'right aligned',
      },
      {
        name: '__slot:estoque',
        dataClass: 'action-slot',
      },
      {
        name: 'nome',
        sortField: 'nome',
        title: this.$t('covid.cidadeSolidaria.tableFields.subprefeitura'),
        callback: (a) => {
          return a || '-'
        },
      },
        // {
        //   name: 'subprefeitura',
        //   sortField: 'subprefeitura',
        //   title: this.$t('covid.cidadeSolidaria.tableFields.subprefeitura'),
        //   callback: (a) => { return a || '-' },
        // },
      {
        name: 'totalDoacoes',
        sortField: 'totalDoacoes',
        title: this.$t('covid.cidadeSolidaria.tableFields.doacoes'),
        callback: (numero) => {
          return MetodosGlobais.formatarGrandesNumeros(numero)
        },
        width: '50%',
      },
        // {
        //   name: 'instituicao',
        //   sortField: 'instituicao',
        //   title: this.$t('covid.cidadeSolidaria.tableFields.instituicao'),
        //   callback: (a) => { return a || '-' },
        // },
      ],
      tableFieldsInstituicao: [{
        name: 'posicao',
        title: '#',
        titleClass: 'center aligned',
        dataClass: 'right aligned',
      },
      {
        name: '__slot:estoque',
        dataClass: 'action-slot',
      },
      {
        name: 'instituicao',
        sortField: 'instituicao',
        title: this.$t('covid.cidadeSolidaria.tableFields.instituicao'),
        callback: (a) => {
          return a || '-'
        },
      },
      {
        name: 'doacoes',
        sortField: 'doacoes',
        title: this.$t('covid.cidadeSolidaria.tableFields.totalDoacoes'),
      },
      ],
      onEachSide: 1,
      dataModeFilterableFields: ['subprefeitura, totalDoacoes'],
      sortFunctionsServ: {
        'subprefeitura': MetodosGlobais.ordenaTabela,
        'nome': MetodosGlobais.ordenaTabela,
        'instituicao': MetodosGlobais.ordenaTabela,
        'totalDoacoes': MetodosGlobais.ordenaTabelaParseInt,
      },
    }
  },
  created () {
    this.$store.dispatch('covid/buscarDoacoesCidadeSolidaria', {
      inicio: '',
    })
      .then(res => {
        this.data = this.popularTabela(res.data.data)
        this.subs = _.orderBy(SPMapaNomes, ['nome'], ['asc'])

        this.pintarTodasRegioes(this.data)
        this.dadosOrdenados = _.orderBy(this.data, ['totalDoacoes'], ['desc'])
        this.tableData.data = this.dadosOrdenados
        this.tableData.dataInstituicao = this.municipio.rank
        this.subSel = this.municipio

        this.dataRef = new Date(res.data.data_referencia_dado).toLocaleDateString('pt-BR')
      })
  },
  computed: {
    tituloTabelaInstituicao: function () {
      return this.$t('covid.cidadeSolidaria.tituloTabelaInstituicao', { local: this.subSelecionada || 'Município' })
    },
    listaCaption: function (m) {
      return `Doações Recebidas ${MetodosGlobais.thousandSeparator(m.doacoes)}`
    },
    titulo (m) {
      return `Doações Recebidas ${this.subSel.nome}`
    },
  },
  methods: {
    updateMultiSelect (value) {
      if (!value) {
        value = this.subSel
      }
      this.filtrarPorRegiao('sub' + value.id)
    },

    popularTabela (dados) {
      let subs = _.clone(SPMapaNomes)
      let clone = _.cloneDeep(dados)

      subs.forEach(element => {
        let leftover = _.remove(clone, (a) => {
          return element.id === a.id_subprefeitura
        })
        element.totalDoacoes = leftover.length
        element.doacoes = leftover
        element.rank = this.rankearDoacoes(leftover)
      })

      subs[0].nome = 'MUNICÍPIO'
      subs[0].totalDoacoes = dados.length
      subs[0].doacoes = dados
      subs[0].rank = this.rankearDoacoes(dados)

      subs = _.orderBy(subs, ['totalDoacoes'], ['desc'])
      this.municipio = subs.shift()
      this.municipio.totalDoacoes = MetodosGlobais.formatarGrandesNumeros(this.municipio.totalDoacoes)

      subs.forEach(a => {
        a.posicao = 1 + subs.indexOf(a)
      })
      subs = _.orderBy(subs, ['totalDoacoes'], ['asc'])

      return subs
    },

    rankearDoacoes (leftover) {
      let clone = _.cloneDeep(leftover)
      let rank = []
      leftover.forEach(function (el) {
       
        let removidos = _.remove(clone, (a) => {
          return el.instituicao.toLowerCase() === a.instituicao.toLowerCase()
        })
        if (removidos.length) {
          rank.push({
            instituicao: removidos[0].instituicao,
            doacoes: removidos.length,
          })
        }
      })
      rank.forEach(a => {
        a.posicao = 1 + rank.indexOf(a)
      })
      rank = _.orderBy(rank, ['doacoes'], ['desc'])
      return rank
    },

    criarTextosDataIntervalo (dataI, dataF, tipo) {
      let dataInicio = MetodosGlobais.dateToJsonDateParts(dataI)
      let dataFim = MetodosGlobais.dateToJsonDateParts(dataF)
      if (tipo === 'fechado') {
        return ` (${MetodosGlobais.mapeiaMesAbreviacao(dataInicio.mes).abrev}/${dataInicio.ano})`
      } else if (tipo === 'completo') {
        return ` (${dataInicio.dia}/${dataInicio.mes}/${dataInicio.ano} a ${dataFim.dia}/${dataFim.mes}/${dataFim.ano})`
      } else {
        return ` (${MetodosGlobais.mapeiaMesAbreviacao(dataInicio.mes).abrev}/${dataInicio.ano} a ${MetodosGlobais.mapeiaMesAbreviacao(dataFim.mes).abrev}/${dataFim.ano})`
      }
    },

    buscaTermoSituacao: _.debounce(function (termoBusca) {
      this.filtraTermoBusca(termoBusca)
    }, 400),

    filtraTermoBusca (termoBusca) {
      if (!termoBusca) {
        this.termoBuscaSituacao = ''
        termoBusca = this.termoBuscaSituacao
      }
      // let servicosFiltrados = []
      // let dataSetEscolhido = this.getDadosSelecionado()
      // let dados = this.buscarTopsPorRegiao(this.ultimoClickIdSub, dataSetEscolhido)
      let dados = this.data

      if ((!Number.isNaN(parseInt(termoBusca))) && termoBusca != '') {
        dados = this.$refs.tabelaDoacoes.filterByNumber(dados, termoBusca)
        // dados = this.$refs.tabelaInstituicao.filterByNumber(dados.rank, termoBusca)
      } else {
        dados = this.$refs.tabelaDoacoes.filterByString(dados, termoBusca)
        // dados = this.$refs.tabelaInstituicao.filterByString(dados.rank, termoBusca)
      }

      dados = _.orderBy(dados, ['totalDoacoes'], ['desc'])

      this.$set(this.tableData, 'data', dados)
      this.$set(this.tableData, 'data', dados)
    },

    limparTermoBusca () {
      this.termoBuscaSituacao = ''
      this.filtraTermoBusca(this.termoBuscaSituacao)
    },

    criarLegenda () {
      this.$refs.mapa.definirLegenda([this.cores.claro, this.cores.medio, this.cores.escuro],
        [this.$t('mainDashboard.legendaTitulo')])
    },

    filtrarPorRegiao (id) {
      let dados = this.data
      let idNum = MetodosGlobais.idSvgToNumeric(id)
      if (this.ultimoClickNomeSub !== id) {
        this.$refs.mapa.limparClick(this.ultimoClickNomeSub)
        this.$refs.mapa.diminuirOpacidadeTodas()
        this.$refs.mapa.aumentarOpacidade(id)
        this.updateTable(idNum)
        this.ultimoClickNomeSub = id
        this.ultimoClickIdSub = idNum
        this.munAtual = dados[idNum].nome
        this.subSelecionada = this.$refs.mapa.nomes[idNum].nome
        this.$refs.mapa.emulateClick(id)
      } else {
        this.$refs.mapa.limparClick(this.ultimoClickNomeSub)
        this.$refs.mapa.aumentarOpacidadeTodas()
        this.ultimoClickNomeSub = null
        this.ultimoClickIdSub = 0
        this.munAtual = this.$t('mainDashboard.general')
        this.subSelecionada = ''
        this.updateTable(0)
      }
      this.subSel = _.find(this.subs, (e) => {
        return e.nome === this.subSelecionada
      })
      this.filtraTermoBusca(this.termoBuscaSituacao)
    },

    formatarNumeroDias (x) {
      let unidade = x > 1 ? this.$t('mainDashboard.days') : this.$t('mainDashboard.day')
      let numeroFormatado = MetodosGlobais.thousandSeparator(x, '.', null)
      return (numeroFormatado + unidade)
    },

    buscarTopsPorRegiao (id, dados) {
      let newTableData = []
      let posicao = 0
      dados[id].servicos.forEach(element => {
        posicao++
        let newObj = {}
        newObj.posicao = posicao
        newObj.nomeServ = element.servico_desc
        newObj.solicitacoesAbertas = element.abertas
        newObj.solicitacoesRecebidas = element.recebidas
        newObj.taxaFechamento = MetodosGlobais.formataPercentual(element.finalizadas / element.total * 100)
        newObj.taxaCancelamento = MetodosGlobais.formataPercentual(element.canceladas / element.total * 100)
        newObj.tempoMedio = parseInt((element.media_atendimento_dias).toFixed(0))
        newObj.tempoMediano = (element.media_atendimento_dias).toFixed(0)
        newObj.finalizadas = element.finalizadas
        newObj.total = element.total
        newObj.estoque = '---'
        newObj.arrowUp = newObj.solicitacoesRecebidas >= newObj.finalizadas ? {
          class: 'red-arrow',
          title: this.$t('mainDashboard.crescimentoEstoque'),
        } : false
        newObj.arrowDown = newObj.solicitacoesRecebidas < newObj.finalizadas ? {
          class: 'green-arrow',
          title: this.$t('mainDashboard.diminuicaoEstoque'),
        } : false
        newTableData.push(newObj)
      })
      return newTableData
    },

    updateTable (id) {
      let dados = null
      if (id > 0) {
        dados = _.find(this.data, { 'id': id })
      } else {
        dados = this.municipio
      }
      dados = _.orderBy(dados.rank, ['doacoes'], ['desc'])
      this.$set(this.tableData, 'dataInstituicao', dados)
    },

    // updateDadosUltimos180Dias (novosDados) {
    //   this.solicitacoes180 = novosDados
    //   let alterado = this.$t('mainDashboard.multiselect.ultimos180Dias') + this.criarTextosDataIntervalo(this.solicitacoes180.data[0].intervalo_inicio, this.solicitacoes180.data[0].intervalo_fim, 'completo')
    //   if (this.corteTemporalEscolhido === this.corteTemporal[3]) {
    //     this.pintarTodasRegioes(this.solicitacoes180.data)
    //     this.setNomesMapa()
    //     this.updateTable(this.ultimoClickIdSub, this.solicitacoes180.data)
    //     this.corteTemporalEscolhido = alterado
    //   }
    //   this.$set(this.corteTemporal, 3, alterado)
    // },
    // updateDadosUltimos30Dias (novosDados) {
    //   this.solicitacoes30 = novosDados
    //   let alterado = this.$t('mainDashboard.multiselect.ultimos30Dias') + this.criarTextosDataIntervalo(this.solicitacoes30.data[0].intervalo_inicio, this.solicitacoes30.data[0].intervalo_fim, 'completo')
    //   if (this.corteTemporalEscolhido === this.corteTemporal[2]) {
    //     this.pintarTodasRegioes(this.solicitacoes30.data)
    //     this.setNomesMapa()
    //     this.updateTable(this.ultimoClickIdSub, this.solicitacoes30.data)
    //     this.corteTemporalEscolhido = alterado
    //   }
    //   this.$set(this.corteTemporal, 2, alterado)
    // },
    // updateDadosUltimoMesFechado (novosDados) {
    //   this.solicitacoesUltimoMes = novosDados
    //   let alterado = this.$t('mainDashboard.multiselect.ultimoMesFechado') + this.criarTextosDataIntervalo(this.solicitacoesUltimoMes.data[0].intervalo_inicio, this.solicitacoesUltimoMes.data[0].intervalo_fim, 'fechado')
    //   if (this.corteTemporalEscolhido === this.corteTemporal[0]) {
    //     this.pintarTodasRegioes(this.solicitacoesUltimoMes.data)
    //     this.setNomesMapa()
    //     this.updateTable(this.ultimoClickIdSub, this.solicitacoesUltimoMes.data)
    //     this.corteTemporalEscolhido = alterado
    //   }
    //   this.$set(this.corteTemporal, 0, alterado)
    // },
    // updateDadosUltimoSemestreFechado (novosDados) {
    //   this.solicitacoesUltimoSemestre = novosDados
    //   let alterado = this.$t('mainDashboard.multiselect.ultimoSemestreFechado') + this.criarTextosDataIntervalo(this.solicitacoesUltimoSemestre.data[0].intervalo_inicio, this.solicitacoesUltimoSemestre.data[0].intervalo_fim)
    //   if (this.corteTemporalEscolhido === this.corteTemporal[1]) {
    //     this.pintarTodasRegioes(this.solicitacoesUltimoSemestre.data)
    //     this.setNomesMapa()
    //     this.updateTable(this.ultimoClickIdSub, this.solicitacoesUltimoSemestre.data)
    //     this.corteTemporalEscolhido = alterado
    //   }
    //   this.$set(this.corteTemporal, 1, alterado)
    // },

    pintarTodasRegioes (data) {
      let max = data[data.length -1].totalDoacoes
      let min = data[0].totalDoacoes

      // Prepara os dados  e remove o Geral
      let dados = _.cloneDeep(data)
      _.remove(dados, (d) => {
        return d.id === -1
      })

      let colorScale = d3.scaleLinear()
        .domain([0.1, max])
        .range([this.cores.claro, this.cores.escuro])

      data.forEach(e => {
        let id = 'sub' + e.id
        this.$refs.mapa.pintarRegiao(id, colorScale(e.totalDoacoes))
      })

      this.$refs.mapa.setLegenda(min, max, this.$t('covid.cidadeSolidaria.mapaLegenda'), 6)
      this.criarLegenda()
    },

    setNomesMapa () {
      var nomes = []
      _.forEach(this.solicitacoes30.data, function (o) { // gerar um ignorando a posicao 0, usar o reduce
        nomes.push({
          nome: o.nome,
          id: o.id,
        })
      })
    },

    setFooterText (resposta) {
      this.dadosFooter = resposta
      this.updateFooterText(0)
    },

    updateFooterText (corte) {
      let dados = this.dadosFooter[corte].data.data
      let abertas = MetodosGlobais.thousandSeparator(dados[0].total + dados[1].total, '.', null)
      let nao_georef = MetodosGlobais.thousandSeparator(dados[0].total, '.', null)
      this.footerTabelaMapa = this.$t('mainDashboard.footerSolicitacoesMunicipio', {
        abertas: abertas,
        nao_georef: nao_georef,
      })
    },
  },
}

</script>

<style lang="scss" scoped>
  #mapaSP {
    width: 35%;
  }

  #tabelaDoacoes {
    width: 100%;
  }

  #chart {
    max-height: 50rem;
  }

  .flex-box {
    max-height: 50rem;
    width: 100%;
    display: flex;
  }

  #multiselects {
    justify-content: space-between;
  }

  .multiselect {
    width: 20rem;
  }

  @media (max-width: 1000px) {
    #chart {
      height: 40rem;
    }
  }

</style>
